module.exports = __webpack_public_path__ + "media/images/emblems/Givrins-coat_of_arms-ef673722ad95e4a85da6a992636e422c.svg";